// extracted by mini-css-extract-plugin
export var editButton = "_k0-0";